<script setup lang="ts">
const { text = 'Laster innhold' } = defineProps<{ text?: string }>()
</script>

<template>
  <div>
    <div class="sr-only">
      {{ text }}
    </div>
    <slot />
  </div>
</template>
